export { default, BFBLogoSmallOnPhone } from './BFBLogo';



// WEBPACK FOOTER //
// ./src/components/BFBLogo/index.js